/**
 * Z85 (ZeroMQ RFC 32) — the text encoding CurveZMQ keys travel in. zeromq.js
 * hands keys out as Z85 strings but the ZAP handler receives the raw 32 bytes,
 * so the two must be convertible in both directions.
 */
const ENCODER = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.-:+=^!/*?&<>()[]{}@%$#';
const DECODER: Record<string, number> = {};
for (let i = 0; i < ENCODER.length; i++) DECODER[ENCODER[i]] = i;

export function z85Encode(data: Uint8Array): string {
  if (data.length % 4 !== 0) throw new Error(`z85Encode: input length ${data.length} is not a multiple of 4.`);
  let out = '';
  for (let i = 0; i < data.length; i += 4) {
    let value = ((data[i] << 24) >>> 0) + (data[i + 1] << 16) + (data[i + 2] << 8) + data[i + 3];
    const chunk: string[] = [];
    for (let j = 0; j < 5; j++) {
      chunk.unshift(ENCODER[value % 85]);
      value = Math.floor(value / 85);
    }
    out += chunk.join('');
  }
  return out;
}

export function z85Decode(text: string): Buffer {
  if (text.length % 5 !== 0) throw new Error(`z85Decode: input length ${text.length} is not a multiple of 5.`);
  const out = Buffer.alloc((text.length / 5) * 4);
  for (let i = 0, o = 0; i < text.length; i += 5, o += 4) {
    let value = 0;
    for (let j = 0; j < 5; j++) {
      const digit = DECODER[text[i + j]];
      if (digit === undefined) throw new Error(`z85Decode: invalid character '${text[i + j]}'.`);
      value = value * 85 + digit;
    }
    if (value > 0xffffffff) throw new Error(`z85Decode: chunk ${i / 5} overflows 32 bits.`);
    out.writeUInt32BE(value, o);
  }
  return out;
}
